import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useFinishImportDonationsMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IImportDonationsJob) => void;
} = {}) => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			systemJobId,
			options,
			impersonationContext,
		}: {
			systemJobId: string;
			options: Api.IImportDonationsOptions;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IImportDonationsJob>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `donation/importFromFile/${systemJobId}`,
				}),
				'POST',
				options
			);
		},
		onError,
		onSuccess,
		retry: false,
	});
};
